// extracted by mini-css-extract-plugin
export default {"nav":"MainNavigation_nav__GVyIy","list":"MainNavigation_list__WpxYN","active":"MainNavigation_active__-QYLh"};